import React from 'react';
import { FaTimes } from 'react-icons/fa';
import '../styles/ResourceHistory.css';

export default function ResourceHistory({ data, onClose }) {
  return (
    <div className="resource-history-overlay">
      <div className="resource-history-modal">
        {/* Header */}
        <div className="resource-history-header">
          <h2>Resources History Detail</h2>
          <button className="resource-history-close" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        {/* All Records */}
        <div className="resource-history-content">
          {data.map((row, idx) => (
            <div key={idx} className="resource-history-box">
              <h3>{row.item} Update</h3>
              <p>
                <strong>Date:</strong> {row.date}
              </p>
              <p>
                <strong>Category:</strong> {row.category}
              </p>
              <p>
                <strong>Item Code:</strong> {row.code}
              </p>
              <p>
                <strong>Quantity:</strong> {row.quantity}
              </p>
              <p>
                <strong>Project:</strong> {row.project}
              </p>
              <p>
                <strong>Remark/Note:</strong> {row.remark}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
